module.exports = __webpack_public_path__ + "static/img/code-of-life-1.0091b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/code-of-life-1.jpg
// module id = GJOY
// module chunks = 1